import { Module } from 'vuex';

import { RootState } from 'frontend/types';
import { DiagrammarExampleGroup } from 'frontend/types/lessons/editor';
import { getJson } from 'frontend/utils/ajax';

interface DiagrammarExamplesState {
  diagrammarExamples: DiagrammarExampleGroup[];
}

const diagrammarExamples: Module<DiagrammarExamplesState, RootState> = {
  namespaced: true,
  state: {
    diagrammarExamples: [],
  },
  mutations: {
    setValue(state, value: DiagrammarExampleGroup[]): void {
      state.diagrammarExamples = value;
    },
  },
  actions: {
    async loadExamples({ commit }): Promise<any> {
      const response = await getJson('/authors/examples/diagrammar/');
      commit('setValue', response.results.diagrammar_examples);
    },
  },
};

export default diagrammarExamples;
